<!-- @format -->

<div class="timekeeper-container">
	<div class="row m-0 btm-row">
		<div class="col-3 p-0">
			<div class="select-title border-btm">
				<h4 class="m-0">Select team member(s):</h4>
			</div>
			<div class="select-title quick-select border-btm top-row">
				<h4>Quick Select:</h4>
				<div class="row d-flex justify-content-between btn-container mx-0">
					<button class="btn btn-link quick-link" (click)="toggleAll(true)" [class.selected]="quickSelect === 'all'">All</button>
					<button class="btn btn-link quick-link" (click)="toggleAll(false)" [class.selected]="quickSelect === 'none'">None</button>
				</div>
			</div>
			<!-- team list-->
			<div [formGroup]="tkForm" class="p-0">
				<div formArrayName="apprEmps">
					<ng-container *ngFor="let user of usersWithExceptions; let i = index">
						<div [formGroupName]="i">
							<div class="employee border-btm" [class.selected]="isSelected(i)">
								<div class="d-flex justify-content-space">
									<label class="container d-flex">
										<div class="img">
											<img class="profile_icon" [src]="getMemberProfile(user.employeeEmail)" />
										</div>
										<div class="employeeName">
											{{user.employeeFirstName + ' ' +
                                            user.employeeLastName}}
										</div>
										<input type="checkbox" formControlName="chkbox" (change)="onChkboxChange($event, user.userId)" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="col-9 p-0">
			<div class="d-flex top-row m-0 week-range border-left justify-content-between">
				<div class="p-2 posting-heading">
					<h2>Time entries with exceptions</h2>
					<p>
						Refresh this page for the latest entries{{isManagerView ? "." : " before you copy."}}
						<span
							*ngIf="!isManagerView"
							class="timekeeperTrigger float-right btn btn-link submit-btn"
							(click)="timekeeperCloseTimeEntry()"
							>Close time entry</span
						>
					</p>
					<div class="timeEntryControl" *ngIf="!isManagerView">
						<div>
							There {{newCount == 1 ? "is" : "are"}} <strong>{{newCount}} new {{newCount == 1 ? "entry" : "entries"}}</strong> since
							your last copy action.
						</div>
						<div class="ppWeek">{{payperiodWeek}}</div>
						<div class="p-2 d-flex align-items-center timeButtons">
							<button (click)="openBatchModal(true)" class="float-right btn btn-link submit-btn">
								<span>Copy with name (temporary)</span>
							</button>
							<button (click)="openBatchModal()" class="float-right btn btn-link submit-btn">
								<span>Copy entries & enter batch #</span>
							</button>
						</div>
					</div>

					<div class="addRegularHourControl" *ngIf="!isManagerView">
						<input
							type="checkbox"
							[(ngModel)]="addRegularHoursChecked"
							(change)="onChkboxAddRegularHours(true)"
							[disabled]="showSystemSubmissionsChecked || addMonthPostingsChecked" />
						Add Regular Hours
					</div>

					<!-- <div class="showSystemSubmissionsControl" *ngIf="!isManagerView">
						<input
							type="checkbox"
							[(ngModel)]="showSystemSubmissionsChecked"
							(change)="onChkboxOnlyShowSystemSubmissions()"
							[disabled]="addRegularHoursChecked || addMonthPostingsChecked" />
						Only Show Approved System Exceptions
					</div> -->

					<div class="addMonthPostingsControl" *ngIf="!isManagerView">
						<input
							type="checkbox"
							[(ngModel)]="addMonthPostingsChecked"
							(change)="onChkboxAddMonthPostings()"
							[disabled]="addRegularHoursChecked || showSystemSubmissionsChecked" />
						Get All {{monthName}} Postings (Temporary)
					</div>

					<!-- <div class="ppWeek">{{payperiodWeek}}</div>
                    <h2>{{currentWeek}}</h2>
                    <p>There are <strong>{{newCount}} new entries</strong> since your last copy action.</p> -->
					<!-- {{selectedEmployees | json}} -->
				</div>

				<!-- <div class="p-2 d-flex align-items-center">
                    <button (click)="timeEntryToClipboardTemporary()" class="float-right btn btn-link submit-btn">Copy
                        with name (temporary)</button>
                    <button (click)="timeEntryToClipboard()" class="float-right btn btn-link submit-btn">Copy
                        all</button>
                </div> -->
			</div>

			<!-- <div class="deadline m-0 border-left d-flex justify-content-start">
                <i class="fa-light fa-hourglass-half fa-xl"></i>
                <strong>Deadline to submit:</strong>
            </div> -->
			<div class="btm-row entries m-0 border-left">
				<table class="table">
					<tr>
						<th>Name</th>
						<th>Emp #</th>
						<th>Date</th>
						<th>Code</th>
						<th>Code description</th>
						<th>Hrs</th>
						<th>Comments</th>
						<th>Approved by</th>
						<th>WO No.</th>
						<th>Rate</th>
						<th>Job type</th>
						<th>Job step</th>
						<th>Batch number</th>
					</tr>
					<tr *ngFor="let entry of timeEntriesFromTimesheets">
						<td>{{userName(entry.userId ?? 0)}}</td>
						<td>{{userEmployeeNumber(entry.userId ?? 0)}}</td>
						<td class="d-flex justify-content-start">
							{{formatDate(entry.entryDate)}}
							<div class="new" *ngIf="entry.isNew">New</div>
						</td>
						<td>{{exceptionCode(entry.exceptionTypeId)}}</td>
						<td>{{exceptionDescription(entry.exceptionTypeId)}}</td>
						<td>{{entry.duration}}</td>
						<td>{{entry.comments}}</td>
						<td>{{getEntrySubmitter(entry)}}</td>
						<td>{{entry.workOrderNumber}}</td>
						<td>{{entry.rate}}</td>
						<td>{{entry.jobType}}</td>
						<td>{{entry.jobStep}}</td>
						<td>{{entry.batchNumber}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>
<ng-template #batchModal>
	<form [formGroup]="batchNumberForm">
		<div class="batch-modal">
			<div class="modal-header">
				<h5 class="modal-title" id="modal-basic-title">Enter the batch number from JDE</h5>
				<button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
			</div>
			<p>Batch number</p>

			<input formControlName="batchNum" class="form-control" />
			<div class="d-flex justify-content-between mt-4">
				<button type="button" class="btn btn-link btn-submission-cancel" (click)="dismissModal()">Cancel</button>
				<button type="submit" class="btn btn-primary btn-submission-submit" (click)="closeModal()" [disabled]="!batchNumberForm.valid">
					Save
				</button>
			</div>
		</div>
	</form>
</ng-template>
